export const TABLE_ROW_COUNT_OPTIONS = [5, 10, 25, 50, 100];
